/**
 * File for Fetching the eLaws Fast Vactor Highlighting body_content snippets through a separate API request as ES App Search does not let you return this field through the SearchUI queries.
 */

// Asynchronous to the results, letting the normal/default results (for title and act title) and this API request fetch at the same time.
async function fetchELawsDescription(queryState, languageState) {
  // Using the `Fetch API`, we create the headers and body for the Elaws FVH description snippets request.
  const requestHeaders = new Headers()
  requestHeaders.append(
    'Authorization',
    `ApiKey ${process.env.REACT_APP_ELAWS_FVH_API_KEY}`,
  )
  requestHeaders.append('Content-Type', 'application/json')

  // The body of the search query.
  // We query the elaws index, using the same field weight values from the Meta Engine, and filter by language.
  // We return the Fast Vector Highlighting body_content highlight array (and upto 5 fragments are returned)
  const requestBody = JSON.stringify({
    _source: ['highlight'],
    query: {
      bool: {
        must: [
          {
            multi_match: {
              query: queryState,
              fields: [
                'title^10',
                'meta_description^3',
                'body_content^0.5',
                'headings^1',
                'act_title^1',
              ],
            },
          },
          {
            match: {
              lang: languageState,
            },
          },
        ],
      },
    },
    highlight: {
      pre_tags: ['<span class="elaws-highlight">'],
      post_tags: ['</span>'],
      order: '_score',
      fields: {
        body_content: {
          matched_fields: ['body_content'],
          type: 'fvh',
          number_of_fragments: 5,
        },
      },
    },
  })

  // The request is POST, as it has a body attached but is only doing a search to the` _search` endpoint
  const requestOptions = {
    method: 'POST',
    headers: requestHeaders,
    body: requestBody,
    redirect: 'follow',
  }

  try {
    // Run the request with the options above.
    // Note: the API URL contains `size=60`, we are limiting the request to only have FVH descriptions for 60 results (~first 3 pages) for efficiency sake.
    const elawsDescriptionResponse = await fetch(
      `${process.env.REACT_APP_ELAWS_FVH_API_URL}`,
      requestOptions,
    ).then(response => response.json())

    // Create a array of objects in order to match IDs of the results from our App search query and this API query
    // to populate the descriptions to the document with the correct ID.
    const temp_fvh_elaws_descriptions = []
    const responseHits = elawsDescriptionResponse?.hits?.hits

    // if the response exists and has results.
    if (responseHits) {
      // For each item in the results of the API call, assign the object key as the ID and the value as the array of FVH snippets.
      responseHits.forEach(item => {
        temp_fvh_elaws_descriptions[item._id] = item.highlight.body_content
      })
      return temp_fvh_elaws_descriptions
    }
    return ''
  } catch (error) {
    console.error(error)
  }
}

export function getELawsDescriptions(queryState, languageState) {
  return fetchELawsDescription(queryState, languageState)
}
